import React, { useContext, useEffect, useRef, useState, useMemo, useCallback } from "react";
import { useTheme } from "@material-ui/core/styles";
import { useHistory, useLocation } from "react-router-dom";
import {
  makeStyles,
  Paper,
  InputBase,
  Tabs,
  Tab,
  Badge,
  IconButton,
  Typography,
  Grid,
  Tooltip,
  Switch,
  List,
  ListItem,
  ListItemText,
  Divider,
  useMediaQuery,
  CircularProgress,
} from "@material-ui/core";
import {
  Group,
  MoveToInbox as MoveToInboxIcon,
  CheckBox as CheckBoxIcon,
  MessageSharp as MessageSharpIcon,
  AccessTime as ClockIcon,
  Search as SearchIcon,
  Add as AddIcon,
  TextRotateUp,
  TextRotationDown,
  CheckBoxOutlined as SelectModeIcon,
  Close as CloseIcon,
  Archive as ArchiveIcon,
} from "@material-ui/icons";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import ToggleButton from "@material-ui/lab/ToggleButton";

import { FilterAltOff, FilterAlt, PlaylistAddCheckOutlined } from "@mui/icons-material";

import NewTicketModal from "../NewTicketModal";
import TicketsList from "../TicketsListCustom";
import TabPanel from "../TabPanel";
import { Can } from "../Can";
import TicketsQueueSelect from "../TicketsQueueSelect";
import { TagsFilter } from "../TagsFilter";
import { UsersFilter } from "../UsersFilter";
import { StatusFilter } from "../StatusFilter";
import { WhatsappsFilter } from "../WhatsappsFilter";
import DateRangeFilter from "../DateRangeFilter";
import { Button, Snackbar } from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import { QueueSelectedContext } from "../../context/QueuesSelected/QueuesSelectedContext";
import { BulkSelectionProvider, useBulkSelection } from "../../context/BulkSelection/BulkSelectionContext";
import { toast } from "react-toastify";

import api from "../../services/api";
import { TicketsContext } from "../../context/Tickets/TicketsContext";
import { format, parseISO } from "date-fns";
import TicketListItemCustom from "../TicketListItemCustom";

const useStyles = makeStyles((theme) => ({
  ticketsWrapper: {
    position: "relative",
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflow: "hidden",
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },

  tabsHeader: {
    minWidth: "auto",
    width: "auto",
    borderRadius: 8,
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    // backgroundColor: "#eee",
    // backgroundColor: theme.palette.tabHeaderBackground,
  },

  settingsIcon: {
    alignSelf: "center",
    marginLeft: "auto",
    padding: theme.spacing(1),
  },

  tab: {
    minWidth: "auto",
    width: "auto",
    padding: theme.spacing(0.5, 1),
    borderRadius: 8,
    transition: "0.3s",
    borderColor: "#aaa",
    borderWidth: "1px",
    borderStyle: "solid",
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),

    [theme.breakpoints.down("lg")]: {
      fontSize: "0.9rem",
      padding: theme.spacing(0.4, 0.8),
      marginRight: theme.spacing(0.4),
      marginLeft: theme.spacing(0.4),
    },

    [theme.breakpoints.down("md")]: {
      fontSize: "0.8rem",
      padding: theme.spacing(0.3, 0.6),
      marginRight: theme.spacing(0.3),
      marginLeft: theme.spacing(0.3),
    },

    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.1)",
    },

    // "&$selected": {
    //   color: "#FFF",
    //   backgroundColor: theme.palette.primary.main,
    // },
  },

  tabPanelItem: {
    minWidth: "33%",
    fontSize: 11,
    marginLeft: 0,
  },

  tabIndicator: {
    height: 6,
    bottom: 0,
    borderRadius: "0 0 8px 8px",
    backgroundColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
  },
  tabsBadge: {
    top: "105%",
    right: "55%",
    transform: "translate(45%, 0)",
    whiteSpace: "nowrap",
    borderRadius: "12px",
    padding: "0 8px",
    backgroundColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    color: theme.mode === "light" ? "#FFF" : theme.palette.primary.main,
  },
  ticketOptionsBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // background: "#fafafa",
    background: theme.palette.optionsBackground,
    borderRadius: 8,
    borderColor: "#aaa",
    borderWidth: "1px",
    borderStyle: "solid",
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    padding: theme.spacing(0.5),
  },

  serachInputWrapper: {
    flex: 1,
    // background: "#fff",
    height: 32,
    background: theme.palette.total,
    display: "flex",
    borderRadius: 32,
    padding: 2,
    borderColor: "#aaa",
    borderWidth: "1px",
    borderStyle: "solid",
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
  },

  searchIcon: {
    color: "grey",
    marginLeft: 6,
    marginRight: 6,
    alignSelf: "center",
  },

  searchInput: {
    flex: 1,
    border: "none",
    borderRadius: 30,
  },

  badge: {
    // right: "-10px",
  },

  customBadge: {
    right: "-10px",
    backgroundColor: "#f44336",
    color: "#fff",
  },
  smoothBadge: {
    transformOrigin: "center",
    transition: "transform 180ms ease-out, background-color 180ms ease-out",
  },
  countPulse: {
    animation: "$pulse 180ms ease-out",
  },
  "@keyframes pulse": {
    "0%": {
      transform: "scale(1)",
    },
    "50%": {
      transform: "scale(1.12)",
    },
    "100%": {
      transform: "scale(1)",
    },
  },

  show: {
    display: "block",
  },

  hide: {
    display: "none !important",
  },

  closeAllFab: {
    backgroundColor: "red",
    marginBottom: "4px",
    "&:hover": {
      backgroundColor: "darkred",
    },
  },

  speedDial: {
    position: "absolute",
    bottom: theme.spacing(1),
    right: theme.spacing(1),
    "& .MuiFab-root": {
      width: "40px",
      height: "40px",
      marginTop: "4px",
    },
    "& .MuiFab-label": {
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },

  snackbar: {
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: theme.palette.primary.main,
    color: "white",
    borderRadius: 30,
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.8em",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "1em",
    },
  },

  yesButton: {
    backgroundColor: "#FFF",
    color: "rgba(0, 100, 0, 1)",
    padding: "4px 4px",
    fontSize: "1em",
    fontWeight: "bold",
    textTransform: "uppercase",
    marginRight: theme.spacing(1),
    "&:hover": {
      backgroundColor: "darkGreen",
      color: "#FFF",
    },
    borderRadius: 30,
  },
  noButton: {
    backgroundColor: "#FFF",
    color: "rgba(139, 0, 0, 1)",
    padding: "4px 4px",
    fontSize: "1em",
    fontWeight: "bold",
    textTransform: "uppercase",
    "&:hover": {
      backgroundColor: "darkRed",
      color: "#FFF",
    },
    borderRadius: 30,
  },
  filterIcon: {
    marginRight: 6,
    alignSelf: "center",
    color: theme.mode === "light" ? "#0872b9" : "#FFF",
    cursor: "pointer",
  },
  button: {
    height: 30,
    width: 30,
    border: "2px solid",
    borderColor: "#aaa",
    borderRadius: 8,
    marginRight: 8,
    "&:hover": {
      borderColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    },
  },
  icon: {
    color: "#aaa",
    "&:hover": {
      color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    },
  },
  buttonOpen: {
    "& $icon": {
      color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    },
  },
}));

// Componente para exibir resultados de busca no formato WhatsApp
const SearchResultsDisplay = ({ tickets, searchParam, onTicketClick, searchOnMessages }) => {
  const classes = useStyles();
  
  // Separar tickets que correspondem ao contato vs mensagens
  const contactMatches = [];
  const messageMatches = [];
  
  tickets.forEach(ticket => {
    const contactName = ticket.contact?.name?.toLowerCase() || '';
    const contactNumber = ticket.contact?.number?.toLowerCase() || '';
    const searchTerm = searchParam.toLowerCase();
    
    // Verificar se o termo de busca corresponde ao contato
    const isContactMatch = contactName.includes(searchTerm) || contactNumber.includes(searchTerm);
    
    if (isContactMatch) {
      contactMatches.push(ticket);
    } else if (ticket.messages && ticket.messages.length > 0) {
      // Se não é match de contato mas tem mensagens, é match de mensagem
      messageMatches.push(ticket);
    }
  });
  
  const highlightSearchTerm = (text, searchTerm) => {
    if (!searchTerm || !text) return text;
    const regex = new RegExp(`(${searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
    return text.replace(regex, '<strong style="background-color: #ffeb3b; padding: 1px 2px; border-radius: 2px;">$1</strong>');
  };

  // Função para navegação ao clicar no ticket
  const handleTicketClick = (ticket) => {
    if (onTicketClick) {
      onTicketClick(ticket);
    }
  };

  return (
    <div style={{ 
      height: 'calc(100vh - 200px)', // Altura fixa para permitir scroll
      overflowY: 'auto', // Scroll vertical
      padding: '8px',
      listStyle: 'none',
      // Melhorar experiência no mobile
      WebkitOverflowScrolling: 'touch' // Scroll suave no iOS
    }}>
      {/* Seção de Contatos - Formato padrão de ticket */}
      {contactMatches.length > 0 && (
        <>
          <Typography variant="subtitle2" style={{ padding: '8px 16px', color: '#666', fontWeight: 'bold', listStyle: 'none' }}>
            Contatos
          </Typography>
          <div style={{ marginBottom: '16px', listStyle: 'none', padding: 0, margin: 0 }}>
            {contactMatches.map((ticket) => (
              <TicketListItemCustom
                key={`contact-${ticket.id}`}
                ticket={ticket}
                setTabOpen={() => onTicketClick(ticket)}
                searchParam={searchParam}
                searchOnMessages={searchOnMessages}
              />
            ))}
          </div>
          {messageMatches.length > 0 && <Divider style={{ margin: '16px 0', listStyle: 'none' }} />}
        </>
      )}
      
      {/* Seção de Mensagens - Formato WhatsApp */}
      {messageMatches.length > 0 && (
        <>
          <Typography variant="subtitle2" style={{ padding: '8px 16px', color: '#666', fontWeight: 'bold', listStyle: 'none' }}>
            Mensagens
          </Typography>
          <List dense disablePadding style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {messageMatches.map((ticket) => (
              <ListItem 
                key={`message-${ticket.id}`}
                button 
                onClick={() => handleTicketClick(ticket)}
                style={{ padding: '8px 16px' }}
              >
                <ListItemText
                  primary={
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span style={{ fontSize: '14px', fontWeight: '500' }}>
                        {ticket.contact?.name || ticket.contact?.number || 'Contato'}
                      </span>
                      <span style={{ fontSize: '12px', color: '#666' }}>
                        {ticket.messages && ticket.messages.length > 0 && 
                         format(parseISO(ticket.messages[0].createdAt), "HH:mm")}
                      </span>
                    </div>
                  }
                  secondary={
                    <div style={{ marginTop: '4px' }}>
                      {ticket.messages && ticket.messages.slice(0, 2).map((message, index) => (
                        <div key={message.id} style={{ marginBottom: '2px', fontSize: '12px' }}>
                          <span style={{ color: '#666' }}>
                            {message.fromMe ? 'Você' : 'Cliente'} - {format(parseISO(message.createdAt), "HH:mm")}:
                          </span>
                          <span 
                            dangerouslySetInnerHTML={{ 
                              __html: highlightSearchTerm(message.body, searchParam) 
                            }} 
                            style={{ marginLeft: '4px' }}
                          />
                        </div>
                      ))}
                    </div>
                  }
                />
              </ListItem>
            ))}
          </List>
        </>
      )}
      
      {contactMatches.length === 0 && messageMatches.length === 0 && (
        <Typography variant="body2" style={{ textAlign: 'center', padding: '16px', color: '#666', listStyle: 'none' }}>
          Nenhum resultado encontrado
        </Typography>
      )}
    </div>
  );
};

// Componente interno que usa o contexto de seleção múltipla
const TicketsManagerTabsContent = () => {
  const theme = useTheme();
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Estados para busca
  const [searchParam, setSearchParam] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [searchOnMessages, setSearchOnMessages] = useState(false);
  const [tab, setTab] = useState("open");
  const searchInputRef = useRef(null);

  const { user, socket } = useContext(AuthContext);
  const { profile } = user;
  const { setSelectedQueuesMessage } = useContext(QueueSelectedContext);
  const { tabOpen, setTabOpen } = useContext(TicketsContext);
  const { toggleSelectionMode, isSelectionMode, disableSelectionMode } = useBulkSelection();

  const [openCount, setOpenCount] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  const [groupingCount, setGroupingCount] = useState(0);
  const ticketStatusRef = useRef(new Map());
  const [pulseOpen, setPulseOpen] = useState(false);
  const [pulsePending, setPulsePending] = useState(false);
  const pendingDeltaRef = useRef({ open: 0, pending: 0 });
  const deltaTimerRef = useRef(null);
  const [initializedOpen, setInitializedOpen] = useState(false);
  const [initializedPending, setInitializedPending] = useState(false);
  const inFlightRef = useRef(new Set());
  const updateCountOpen = useCallback((val) => {
    if (!initializedOpen) {
      setOpenCount(val);
      setInitializedOpen(true);
    }
  }, [initializedOpen]);
  const updateCountPending = useCallback((val) => {
    if (!initializedPending) {
      setPendingCount(val);
      setInitializedPending(true);
    }
  }, [initializedPending]);
  

  const userQueueIds = user.queues.map((q) => q.id);
  const [selectedQueueIds, setSelectedQueueIds] = useState(userQueueIds || []);
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedWhatsapp, setSelectedWhatsapp] = useState([]);
  const [forceSearch, setForceSearch] = useState(Date.now());
  const [refreshKey, setRefreshKey] = useState(0);
  const [updateTrigger, setUpdateTrigger] = useState(0);
  const lastForceRef = useRef(0);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [dateRange, setDateRange] = useState({ dateStart: "", dateEnd: "", filterType: "createdAt" });
  const [appliedDateRange, setAppliedDateRange] = useState({ dateStart: "", dateEnd: "", filterType: "createdAt" });
  const [showAllTickets, setShowAllTickets] = useState(false);
  const [sortTickets, setSortTickets] = useState(false);
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  
  // Estados para valores temporários (não aplicados)
  const [tempSelectedTags, setTempSelectedTags] = useState([]);
  const [tempSelectedUsers, setTempSelectedUsers] = useState([]);
  const [tempSelectedWhatsapp, setTempSelectedWhatsapp] = useState([]);
  const [tempSelectedStatus, setTempSelectedStatus] = useState([]);
  const [tempDateRange, setTempDateRange] = useState({ dateStart: "", dateEnd: "", filterType: "createdAt" });
  
  // Inicializar os valores temporários com os valores aplicados
  useEffect(() => {
    setTempSelectedTags(selectedTags);
    setTempSelectedUsers(selectedUsers);
    setTempSelectedWhatsapp(selectedWhatsapp);
    setTempSelectedStatus(selectedStatus);
    setTempDateRange(appliedDateRange);
  }, [selectedTags, selectedUsers, selectedWhatsapp, selectedStatus, appliedDateRange]);
  
  const [filter, setFilter] = useState(false);
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [filterKey, setFilterKey] = useState(0);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [hoveredButton, setHoveredButton] = useState(null);
  const [isHoveredAll, setIsHoveredAll] = useState(false);
  const [isHoveredNew, setIsHoveredNew] = useState(false);
  const [isHoveredResolve, setIsHoveredResolve] = useState(false);
  const [isHoveredOpen, setIsHoveredOpen] = useState(false);
  const [isHoveredClosed, setIsHoveredClosed] = useState(false);
  const [isHoveredSort, setIsHoveredSort] = useState(false);
  const [isHoveredFilter, setIsHoveredFilter] = useState(false);
  const [isHoveredArquivados, setIsHoveredArquivados] = useState(false);

  const [isFilterActive, setIsFilterActive] = useState(false);
  
  useEffect(() => {
    setInitializedOpen(false);
    setInitializedPending(false);
    ticketStatusRef.current = new Map();
  }, [
    selectedQueueIds,
    selectedTags,
    selectedUsers,
    selectedWhatsapp,
    selectedStatus,
    appliedDateRange,
    showAllTickets,
    sortTickets
  ]);

  // Preservar estado da busca quando navegar para ticket específico
  useEffect(() => {
    // Quando entrar na página, verificar se há estado de busca salvo
    const savedSearchState = sessionStorage.getItem('searchState');
    if (savedSearchState) {
      try {
        const parsedState = JSON.parse(savedSearchState);
        setSearchParam(parsedState.searchParam || "");
        setSearchResults(parsedState.searchResults || []);
        setShowSearchResults(parsedState.showSearchResults || false);
        setTab(parsedState.tab || "search");
        setSearchOnMessages(parsedState.searchOnMessages !== undefined ? parsedState.searchOnMessages : false);

        // Restaurar filtros aplicados
        if (parsedState.selectedTags) setSelectedTags(parsedState.selectedTags);
        if (parsedState.selectedUsers) setSelectedUsers(parsedState.selectedUsers);
        if (parsedState.selectedWhatsapp) setSelectedWhatsapp(parsedState.selectedWhatsapp);
        if (parsedState.selectedStatus) setSelectedStatus(parsedState.selectedStatus);
        if (parsedState.selectedQueueIds) setSelectedQueueIds(parsedState.selectedQueueIds);
        if (parsedState.dateRange) setDateRange(parsedState.dateRange);
        if (parsedState.appliedDateRange) setAppliedDateRange(parsedState.appliedDateRange);
        if (parsedState.showAllTickets !== undefined) setShowAllTickets(parsedState.showAllTickets);
        if (parsedState.sortTickets !== undefined) setSortTickets(parsedState.sortTickets);
        if (parsedState.filtersApplied !== undefined) setFiltersApplied(parsedState.filtersApplied);

        // Verificar se há filtros ativos e definir filtersApplied como true
        const hasActiveFilters = (
          (parsedState.selectedTags && parsedState.selectedTags.length > 0) ||
          (parsedState.selectedUsers && parsedState.selectedUsers.length > 0) ||
          (parsedState.selectedWhatsapp && parsedState.selectedWhatsapp.length > 0) ||
          // Removida verificação do status filter
          (parsedState.appliedDateRange && parsedState.appliedDateRange.dateStart && parsedState.appliedDateRange.dateEnd)
        );
        
        if (hasActiveFilters) {
          setFiltersApplied(true);
          console.log('Filtros ativos detectados, definindo filtersApplied como true');
        }

        // Restaurar o valor do campo de busca visualmente
        if (searchInputRef.current && parsedState.searchParam) {
          searchInputRef.current.value = parsedState.searchParam;
        }

        // Se há resultados de busca, garantir que a aba search esteja ativa
        if (parsedState.searchResults && parsedState.searchResults.length > 0) {
          setTab("search");
        }
      } catch (error) {
        console.error('Erro ao restaurar estado da busca:', error);
      }
    }
  }, []);

  // Salvar estado da busca quando mudar
  useEffect(() => {
    const searchState = {
      searchParam,
      searchResults,
      showSearchResults,
      tab,
      searchOnMessages,
      selectedTags,
      selectedUsers,
      selectedWhatsapp,
      selectedStatus,
      selectedQueueIds,
      dateRange,
      appliedDateRange,
      showAllTickets,
      sortTickets,
      filtersApplied
    };
    sessionStorage.setItem('searchState', JSON.stringify(searchState));
  }, [
    searchParam,
    searchResults,
    showSearchResults,
    tab,
    searchOnMessages,
    selectedTags,
    selectedUsers,
    selectedWhatsapp,
    selectedStatus,
    selectedQueueIds,
    dateRange,
    appliedDateRange,
    showAllTickets,
    sortTickets,
    filtersApplied
  ]);

  // Limpar estado salvo quando a busca for limpa manualmente
  const clearSearchState = () => {
    sessionStorage.removeItem('searchState');
    setSearchParam("");
    setSearchResults([]);
    setShowSearchResults(false);
    setTab("open");
    setSearchOnMessages(false);

    // Limpar filtros aplicados
    setSelectedTags([]);
    setSelectedUsers([]);
    setSelectedWhatsapp([]);
    setSelectedStatus([]);
    setSelectedQueueIds([]);
    setDateRange({ dateStart: "", dateEnd: "", filterType: "createdAt" });
    setAppliedDateRange({ dateStart: "", dateEnd: "", filterType: "createdAt" });
    setShowAllTickets(false);
    setSortTickets(false);
    setFiltersApplied(false); // Limpar o estado de filtros aplicados

    // Limpar o campo de busca visualmente
    if (searchInputRef.current) {
      searchInputRef.current.value = "";
    }
  };

  // Atualizar contadores rapidamente ao receber eventos de ticket
  useEffect(() => {
    if (!socket || !user?.companyId) return;
    const companyId = user.companyId;

    const onCompanyTicketTabs = (data) => {
      if (!data) return;
      if (data.action === "update") {
        const status = data.ticket?.status;
        if (status === "pending") {
          return;
        }
      }
      if (data.action === "update" || data.action === "delete") {
        const now = Date.now();
        if (now - lastForceRef.current > 300) {
          lastForceRef.current = now;
          setForceSearch(now);
        }
      }
    };

    socket.on(`company-${companyId}-ticket`, onCompanyTicketTabs);
    return () => {
      socket.off(`company-${companyId}-ticket`, onCompanyTicketTabs);
    };
  }, [socket, user?.companyId]);

  useEffect(() => {
    setSelectedQueuesMessage(selectedQueueIds);
  }, [selectedQueueIds]);

  // Função para forçar atualização dos tickets
  const forceUpdateTickets = useCallback(() => {
    const newTimestamp = Date.now();
    console.log("Forçando atualização dos tickets...", { 
        timestamp: newTimestamp,
        previousForceSearch: forceSearch,
        previousRefreshKey: refreshKey,
        previousUpdateTrigger: updateTrigger
    });
    setForceSearch(newTimestamp);
    setRefreshKey(prev => prev + 1);
    setUpdateTrigger(prev => prev + 1);
  }, [forceSearch, refreshKey, updateTrigger]);

  // Função para redirecionar para tickets arquivados
  const handleArquivadosClick = () => {
    // Definir no localStorage que deve abrir a aba arquivados
    localStorage.setItem('kanbanInitialTab', 'archived');
    // Redirecionar para a tela CRM/kanban
    history.push('/kanban');
  };

  // Escutar notificações de usuário para atualizar tickets automaticamente
  useEffect(() => {
    if (socket && user) {
      const companyId = user.companyId;
      
      const onCompanyUser = (data) => {
        if (data.action === "update" && data.user && data.user.id === user.id) {
          // Se o usuário logado foi atualizado, forçar atualização dos tickets
          console.log("Usuário atualizado, recarregando tickets...", {
            userId: data.user.id,
            action: data.action,
            timestamp: Date.now(),
            whatsappId: data.user.whatsappId,
            previousWhatsappId: user.whatsappId
          });
          forceUpdateTickets();
        }
      };

      socket.on(`company-${companyId}-user`, onCompanyUser);

      return () => {
        socket.off(`company-${companyId}-user`, onCompanyUser);
      };
    }
  }, [socket, user, forceUpdateTickets]);

  // Forçar atualização quando updateTrigger mudar
  useEffect(() => {
    console.log("updateTrigger mudou, forçando atualização dos tickets...", { 
        updateTrigger, 
        timestamp: Date.now() 
    });
  }, [updateTrigger]);

  useEffect(() => {
    const isAdmin = user.profile === "admin" || user.profile === "ADMIN" || user.profile === "Admin";
    const hasAllUserChat = user.allUserChat === "enabled" || 
                          user.allUserChat === "ENABLED" || 
                          user.allUserChat === "Enabled";
    
    if (isAdmin || hasAllUserChat) {
      setShowAllTickets(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (tab === "search") {
      searchInputRef.current.focus();
    }
    setForceSearch(Date.now());
  }, [tab]);

  useEffect(() => {
    // Primeiro tenta pegar da URL (mantém compatibilidade)
    const params = new URLSearchParams(location.search);
    const tabParam = params.get('tab');
    let initialTab = tabParam;

    // Se não veio da URL, tenta pegar do sessionStorage
    if (!initialTab) {
      initialTab = sessionStorage.getItem('forceTabOpen');
      if (initialTab) sessionStorage.removeItem('forceTabOpen');
    }

    if (initialTab && ['open', 'pending', 'group', 'closed'].includes(initialTab)) {
      setTabOpen(initialTab);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  // Debounce para busca em mensagens, evitando muitas requisições durante a digitação
  const searchDebounceRef = useRef(null);
  const MIN_SEARCH_LENGTH = 2;

  useEffect(() => {
    // Limpa qualquer busca pendente
    if (searchDebounceRef.current) {
      clearTimeout(searchDebounceRef.current);
    }

    // Se não estiver buscando em mensagens, limpa resultados e não dispara busca
    if (!searchOnMessages) {
      setShowSearchResults(false);
      setSearchResults([]);
      return;
    }

    const term = (searchParam || "").trim();

    // Se termo vazio ou curto, limpa resultados e não busca
    if (!term || term.length < MIN_SEARCH_LENGTH) {
      setShowSearchResults(false);
      setSearchResults([]);
      return;
    }

    // Aguarda um pequeno intervalo antes de disparar a busca
    searchDebounceRef.current = setTimeout(() => {
      handleSearchWithNewFormat();
    }, 500);

    return () => {
      if (searchDebounceRef.current) {
        clearTimeout(searchDebounceRef.current);
      }
    };
  }, [searchParam, searchOnMessages]);

  // Timeout gerenciado via searchDebounceRef acima

  const handleSearchWithNewFormat = async () => {
    const term = (searchParam || "").trim();
    if (!searchOnMessages || !term || term.length < MIN_SEARCH_LENGTH) {
      setShowSearchResults(false);
      setSearchResults([]);
      setIsSearching(false);
      return;
    }

    setIsSearching(true);
    try {
      const { data } = await api.get("/tickets", {
        params: {
          searchParam: searchParam,
          pageNumber: "1",
          status: "search",
          showAll: showAllTickets ? "true" : "false",
          tags: selectedTags.length > 0 ? JSON.stringify(selectedTags.map(tag => tag.id)) : undefined,
          users: selectedUsers.length > 0 ? JSON.stringify(selectedUsers.map(user => user.id)) : undefined,
          queueIds: selectedQueueIds.length > 0 ? JSON.stringify(selectedQueueIds) : undefined,
          whatsappIds: selectedWhatsapp.length > 0 ? JSON.stringify(selectedWhatsapp.map(whatsapp => whatsapp.id)) : undefined,
          statusFilter: selectedStatus.length > 0 ? JSON.stringify(selectedStatus.map(status => status.status)) : undefined,
          searchOnMessages: "true"
        },
      });
      
      setSearchResults(data.tickets || []);
      setShowSearchResults(true);
    } catch (err) {
      console.error("Erro ao buscar resultados:", err);
      setSearchResults([]);
      setShowSearchResults(false);
    } finally {
      setIsSearching(false);
    }
  };

  const handleSearch = (e) => {
    const searchedTermRaw = e.target.value || "";
    const searchedTerm = searchedTermRaw.toLowerCase();

    // Atualiza o termo de busca; o debounce cuidará de disparar a busca quando aplicável
    setSearchParam(searchedTerm);

    if (searchedTerm === "") {
      setSearchParam(searchedTerm);
      setForceSearch(Date.now());
      setShowSearchResults(false);
      setSearchResults([]);
      setTab("open");
      // Para buscas por atendimentos (não mensagens), manter comportamento de forçar recarga
      if (!searchOnMessages) {
        setForceSearch(Date.now());
      }
      return;
    }

    // Garantir que a aba de busca esteja ativa quando houver termo
    if (tab !== "search") {
      setTab("search");
    }
    
    // Limpar timeout anterior se existir
    if (searchDebounceRef.current) {
      clearTimeout(searchDebounceRef.current);
    }
    
         searchDebounceRef.current = setTimeout(async () => {
       setSearchParam(searchedTerm);
       setForceSearch(Date.now());
       
       // Se searchOnMessages está ativo, buscar resultados no novo formato
       if (searchOnMessages && searchedTerm.trim()) {
         await handleSearchWithNewFormat();
       } else {
         setShowSearchResults(false);
         setSearchResults([]);
       }
     }, 500);
  };

  const handleBack = () => {

    history.push("/tickets");
  };

  const handleChangeTab = (e, newValue) => {
    // Limpa a seleção ao trocar entre diferentes tipos de abas (open, closed, search)
    if (isSelectionMode) {
      disableSelectionMode();
    }
    
    setTab(newValue);
  };

  const handleChangeTabOpen = (e, newValue) => {
    // if (newValue === "pending" || newValue === "group") {
    handleBack();
    // }

    // Limpa a seleção ao trocar de aba para evitar misturar tickets de status diferentes
    if (isSelectionMode) {
      disableSelectionMode();
    }

    // Não limpa os filtros ao trocar entre "Atendendo" e "Aguardando"
    setTabOpen(newValue);
  };
  const handleIdsLoaded = useCallback(({ ids, status }) => {
    if (!Array.isArray(ids)) return;
    const map = ticketStatusRef.current;
    ids.forEach((id) => {
      const prev = map.get(id);
      if (!prev) {
        map.set(id, status);
      }
    });
  }, []);
  useEffect(() => {
    if (!socket || !user?.companyId) return;
    const companyId = user.companyId;
    const onCompanyTicketTabs = (data) => {
      if (!data || !data.ticket) return;
      const id = data.ticket.id;
      const nextStatus = data.ticket.status;
      if (Array.isArray(selectedQueueIds) && selectedQueueIds.length > 0) {
        if (selectedQueueIds.indexOf(data.ticket.queueId) === -1) return;
      }
      const prevStatus = ticketStatusRef.current.get(id);
      if (data.action === "removeFromList") {
        inFlightRef.current.add(id);
        if (prevStatus === "pending") {
          setPendingCount((v) => Math.max(0, v - 1));
          setPulsePending(true);
        } else if (prevStatus === "open") {
          setOpenCount((v) => Math.max(0, v - 1));
          setPulseOpen(true);
        }
        return;
      }
      if (data.action === "delete") {
        if (prevStatus === "pending") {
          setPendingCount((v) => Math.max(0, v - 1));
          setPulsePending(true);
        } else if (prevStatus === "open") {
          setOpenCount((v) => Math.max(0, v - 1));
          setPulseOpen(true);
        }
        ticketStatusRef.current.delete(id);
        inFlightRef.current.delete(id);
        return;
      }
      if (!prevStatus) {
        ticketStatusRef.current.set(id, nextStatus);
        return;
      }
      if (prevStatus !== nextStatus) {
        if (prevStatus === "pending" && nextStatus === "open") {
          if (inFlightRef.current.has(id)) {
            setOpenCount((v) => v + 1);
            setPulseOpen(true);
            inFlightRef.current.delete(id);
          } else {
            setPendingCount((v) => Math.max(0, v - 1));
            setOpenCount((v) => v + 1);
            setPulsePending(true);
            setPulseOpen(true);
          }
        } else if (prevStatus === "open" && nextStatus === "pending") {
          if (inFlightRef.current.has(id)) {
            setPendingCount((v) => v + 1);
            setPulsePending(true);
            inFlightRef.current.delete(id);
          } else {
            setOpenCount((v) => Math.max(0, v - 1));
            setPendingCount((v) => v + 1);
            setPulseOpen(true);
            setPulsePending(true);
          }
        }
        ticketStatusRef.current.set(id, nextStatus);
      }
    };
    socket.on(`company-${companyId}-ticket`, onCompanyTicketTabs);
    return () => {
      socket.off(`company-${companyId}-ticket`, onCompanyTicketTabs);
    };
  }, [socket, user?.companyId, selectedQueueIds]);

  useEffect(() => {
    if (pulseOpen) {
      const t = setTimeout(() => setPulseOpen(false), 200);
      return () => clearTimeout(t);
    }
  }, [pulseOpen]);

  useEffect(() => {
    if (pulsePending) {
      const t = setTimeout(() => setPulsePending(false), 200);
      return () => clearTimeout(t);
    }
  }, [pulsePending]);

  const applyPanelStyle = (status) => {
    if (tabOpen !== status) {
      return { width: 0, height: 0 };
    }
  };

  const handleSnackbarOpen = () => {
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const CloseAllTicket = async () => {
    try {
      const { data } = await api.post("/tickets/closeAll", {
        status: tabOpen,
        selectedQueueIds,
      });
      handleSnackbarClose();
    } catch (err) {
      console.log("Error: ", err);
    }
  };

  const handleCloseOrOpenTicket = (ticket) => {
    setNewTicketModalOpen(false);
    if (ticket !== undefined && ticket.uuid !== undefined) {
      history.push(`/tickets/${ticket.uuid}`);
    }
  };



  const handleSearchResultClick = (ticket) => {
    if (ticket !== undefined && ticket.uuid !== undefined) {
      // Navegar diretamente para o ticket específico do resultado clicado
      // NÃO limpar a pesquisa - manter para que o usuário possa ver outros resultados
      history.push(`/tickets/${ticket.uuid}`);
      
      // No mobile, mostrar notificação de sucesso
      if (isMobile) {
        toast.success(`Redirecionando para ${ticket.contact?.name || ticket.contact?.number || 'Contato'}`, {
          position: "top-center",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    }
  };

  const handleSelectedTags = (selecteds) => {
    // Para o backend, enviar apenas os IDs
    const tagIds = selecteds.map((t) => t.id);
    // Para o frontend, salvar as tags completas
    const tags = selecteds.map((t) => ({ id: t.id, name: t.name, color: t.color }));

    // Salvar nos valores temporários
    setTempSelectedTags(tags);
  };

  const handleSelectedUsers = (selecteds) => {
    // Para o backend, enviar apenas os IDs
    const userIds = selecteds.map((t) => t.id);
    // Para o frontend, salvar os usuários completos
    const users = selecteds.map((t) => ({ id: t.id, name: t.name }));

    // Salvar nos valores temporários
    setTempSelectedUsers(users);
  };

  const handleSelectedWhatsapps = (selecteds) => {
    // Para o backend, enviar apenas os IDs
    const whatsappIds = selecteds.map((t) => t.id);
    // Para o frontend, salvar os whatsapps completos
    const whatsapp = selecteds.map((t) => ({ id: t.id, name: t.name, channel: t.channel }));

    // Salvar nos valores temporários
    setTempSelectedWhatsapp(whatsapp);
  };

  const handleSelectedStatus = (selecteds) => {
    // Para o backend, enviar apenas os status
    const statusIds = selecteds.map((t) => t.status);
    // Para o frontend, salvar os status completos
    const statusFilter = selecteds.map((t) => ({ status: t.status, name: t.name, color: t.color }));

    // Salvar nos valores temporários
    setTempSelectedStatus(statusFilter);
  };

  const handleDateRangeFilter = (dateRangeData) => {
    // Salvar nos valores temporários
    setTempDateRange(dateRangeData);
  };

  const handleFilterTypeChange = (filterType) => {
    // Atualizar o tipo de filtro no dateRange temporário
    setTempDateRange(prev => ({ ...prev, filterType }));
  };

  const handleApplyFilters = () => {
    
    // Aplicar todos os valores temporários para os estados aplicados
    setSelectedTags(tempSelectedTags);
    setSelectedUsers(tempSelectedUsers);
    setSelectedWhatsapp(tempSelectedWhatsapp);
    setSelectedStatus(tempSelectedStatus);
    setAppliedDateRange(tempDateRange);
    setFiltersApplied(true);
    setFilter(false); // Minimiza os filtros
    // Não muda mais para a aba search, mantém na aba atual
         setForceSearch(Date.now()); // Força a busca com os filtros aplicados
  };

  // Memoizar os valores dos filtros para evitar re-renders desnecessários
  const memoizedFilterValues = useMemo(() => ({
    initialDateRange: appliedDateRange,
    initialSelectedTags: selectedTags,
    initialSelectedWhatsapps: selectedWhatsapp,
    initialSelectedStatus: selectedStatus,
    initialSelectedUsers: selectedUsers,
  }), [appliedDateRange, selectedTags, selectedWhatsapp, selectedStatus, selectedUsers]);



  // Função para sincronizar os valores dos filtros quando abrir o painel
  const syncFilterValues = () => {
    // Sempre mostrar os filtros aplicados quando abrir o painel
    setTempDateRange(appliedDateRange);
    setTempSelectedTags(selectedTags);
    setTempSelectedUsers(selectedUsers);
    setTempSelectedWhatsapp(selectedWhatsapp);
    setTempSelectedStatus(selectedStatus);
  };

  const handleClearFilters = () => {
    setFiltersApplied(false);
    setDateRange({ dateStart: "", dateEnd: "", filterType: "createdAt" });
    setAppliedDateRange({ dateStart: "", dateEnd: "", filterType: "createdAt" });
    setSelectedTags([]);
    setSelectedUsers([]);
    setSelectedWhatsapp([]);
    setSelectedStatus([]);
    
    // Limpar também os valores temporários
    setTempDateRange({ dateStart: "", dateEnd: "", filterType: "createdAt" });
    setTempSelectedTags([]);
    setTempSelectedUsers([]);
    setTempSelectedWhatsapp([]);
    setTempSelectedStatus([]);
    
    // Força a re-renderização dos componentes de filtro
    setFilterKey(prev => prev + 1);
    
         // Força a busca para limpar os resultados
     setForceSearch(Date.now());
  };

  const handleFilter = () => {
    // Limpa a seleção ao ativar/desativar filtros
    if (isSelectionMode) {
      disableSelectionMode();
    }
    
    if (filter) {
      setFilter(false);
      setTab("open");
      // Não limpa os filtros aplicados, apenas fecha o painel
    } else {
      setFilter(true);
      // Sincronizar valores quando abrir os filtros
      syncFilterValues();
      // Não muda mais para a aba search automaticamente
    }
  };

  const [open, setOpen] = React.useState(false);
  const [hidden, setHidden] = React.useState(false);

  const handleVisibility = () => {
    setHidden((prevHidden) => !prevHidden);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClosed = () => {
    setOpen(false);
  };

  const tooltipTitleStyle = {
    fontSize: "10px",
  };

  // Função para contar quantos filtros estão aplicados
  const getActiveFiltersCount = () => {
    let count = 0;
    
    if (selectedTags.length > 0) count++;
    if (selectedUsers.length > 0) count++;
    if (selectedWhatsapp.length > 0) count++;
    // Removido contagem do status filter
    if (appliedDateRange.dateStart && appliedDateRange.dateEnd) count++;
    
    return count;
  };

  return (
    <Paper elevation={0} variant="outlined" className={classes.ticketsWrapper}>
      <NewTicketModal
        modalOpen={newTicketModalOpen}
        onClose={(ticket) => {
          handleCloseOrOpenTicket(ticket);
        }}
      />
      <Paper square elevation={0} className={classes.ticketOptionsBox}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Can
              role={user.allUserChat === 'enabled' && user.profile === 'user' ? 'admin' : user.profile}
              perform="tickets-manager:showall"
              yes={() => (
                <Badge
                  color="primary"
                  invisible={
                    !isHoveredAll ||
                    isHoveredNew ||
                    isHoveredResolve ||
                    isHoveredOpen ||
                    isHoveredClosed
                  }
                  badgeContent={"Todos"}
                  classes={{ badge: classes.tabsBadge }}
                >
                  <ToggleButton
                    onMouseEnter={() => setIsHoveredAll(true)}
                    onMouseLeave={() => setIsHoveredAll(false)}
                    className={classes.button}
                    value="uncheck"
                    selected={showAllTickets}
                    onChange={() =>
                      setShowAllTickets((prevState) => !prevState)
                    }
                  >
                    {showAllTickets ? (
                      <VisibilityIcon className={classes.icon} />
                    ) : (
                      <VisibilityOffIcon className={classes.icon} />
                    )}
                  </ToggleButton>
                </Badge>
              )}
            />
            <Snackbar
              open={snackbarOpen}
              onClose={handleSnackbarClose}
              message={i18n.t("tickets.inbox.closedAllTickets")}
              ContentProps={{
                className: classes.snackbar,
              }}
              action={
                <>
                  <Button
                    className={classes.yesButton}
                    size="small"
                    onClick={CloseAllTicket}
                  >
                    {i18n.t("tickets.inbox.yes")}
                  </Button>
                  <Button
                    className={classes.noButton}
                    size="small"
                    onClick={handleSnackbarClose}
                  >
                    {i18n.t("tickets.inbox.no")}
                  </Button>
                </>
              }
            />
            <Badge
              color="primary"
              invisible={
                isHoveredAll ||
                !isHoveredNew ||
                isHoveredResolve ||
                isHoveredOpen ||
                isHoveredClosed
              }
              badgeContent={i18n.t("tickets.inbox.newTicket")}
              classes={{ badge: classes.tabsBadge }}
            >
              <IconButton
                onMouseEnter={() => setIsHoveredNew(true)}
                onMouseLeave={() => setIsHoveredNew(false)}
                className={classes.button}
                onClick={() => {
                  setNewTicketModalOpen(true);
                }}
              >
                <AddIcon className={classes.icon} />
              </IconButton>
            </Badge>
            
            {/* Ícone de Filtro - SEMPRE VISÍVEL PARA TODOS */}
            <Badge
              overlap="rectangular"
              invisible={
                (!isHoveredFilter && !filtersApplied) ||
                isHoveredResolve ||
                isHoveredOpen ||
                isHoveredClosed
              }
              badgeContent={filtersApplied ? `Filtros (${getActiveFiltersCount()})` : "Filtros"}
              classes={{ badge: classes.tabsBadge }}
            >
              <ToggleButton
                onMouseEnter={() => setIsHoveredFilter(true)}
                onMouseLeave={() => setIsHoveredFilter(false)}
                className={classes.button}
                value="uncheck"
                selected={isFilterActive || filtersApplied}
                onChange={() => {
                  setIsFilterActive((prevState) => !prevState);
                  handleFilter();
                }}
                style={{
                  backgroundColor: filtersApplied ? theme.palette.primary.main : "transparent",
                  color: filtersApplied ? "white" : "#aaa"
                }}
              >
                {isFilterActive || filtersApplied ? (
                  <FilterAlt style={{
                    color: filtersApplied ? "white" : "#aaa",
                  }} />
                ) : (
                  <FilterAltOff style={{
                    color: "#aaa",
                  }} />
                )}
              </ToggleButton>
            </Badge>
            
            {/* Botão Arquivados */}
            <Badge
              color="primary"
              invisible={
                isHoveredAll ||
                isHoveredNew ||
                isHoveredFilter ||
                !isHoveredArquivados ||
                isHoveredOpen ||
                isHoveredClosed
              }
              badgeContent="Arquivados"
              classes={{ badge: classes.tabsBadge }}
            >
              <IconButton
                onMouseEnter={() => setIsHoveredArquivados(true)}
                onMouseLeave={() => setIsHoveredArquivados(false)}
                className={classes.button}
                onClick={handleArquivadosClick}
                style={{
                  height: 30,
                  width: 30,
                  border: isHoveredArquivados
                    ? theme.mode === "light"
                      ? "3px solid " + theme.palette.primary.main
                      : "3px solid #FFF"
                    : theme.mode === "light"
                      ? "2px solid #aaa"
                      : "2px solid #aaa",
                  borderRadius: 8,
                  marginRight: 8,
                }}
              >
                <ArchiveIcon style={{ 
                  color: isHoveredArquivados
                    ? theme.mode === "light"
                      ? theme.palette.primary.main
                      : "#FFF"
                    : "#aaa",
                }} />
              </IconButton>
            </Badge>
            
            {user.profile === "admin" && (
              <Badge
                color="primary"
                invisible={
                  isHoveredAll ||
                  isHoveredNew ||
                  !isHoveredResolve ||
                  isHoveredOpen ||
                  isHoveredClosed
                }
                badgeContent={i18n.t("tickets.inbox.closedAll")}
                classes={{ badge: classes.tabsBadge }}
              >
                <IconButton
                  onMouseEnter={() => setIsHoveredResolve(true)}
                  onMouseLeave={() => setIsHoveredResolve(false)}
                  className={classes.button}
                  onClick={handleSnackbarOpen}
                >
                  <PlaylistAddCheckOutlined style={{ color: theme.mode === "light" ? "green" : "#FFF" }} />
                </IconButton>
              </Badge>
            )}
            
            {/* Botão para ativar modo de seleção múltipla - para admin ou usuários com permissão */}
            {(user.profile === "admin" || user.allowBulkTicketActions === "enabled") && (
              <Tooltip title={isSelectionMode ? "Sair do modo seleção" : "Selecionar múltiplos tickets"}>
                <IconButton
                  className={classes.button}
                  onClick={toggleSelectionMode}
                  style={{
                    backgroundColor: isSelectionMode ? theme.palette.primary.main : "transparent",
                    color: isSelectionMode ? "white" : (theme.mode === "light" ? theme.palette.primary.main : "#FFF"),
                  }}
                >
                  <SelectModeIcon />
                </IconButton>
              </Tooltip>
            )}
            <Badge
              // color="primary"
              invisible={
                !(
                  tab === "open" &&
                  !isHoveredAll &&
                  !isHoveredNew &&
                  !isHoveredResolve &&
                  !isHoveredClosed &&
                  !isHoveredSort
                ) && !isHoveredOpen
              }
              badgeContent={i18n.t("tickets.inbox.open")}
              classes={{ badge: classes.tabsBadge }}
            >
              <IconButton
                onMouseEnter={() => {
                  setIsHoveredOpen(true);
                  setHoveredButton("open");
                }}
                onMouseLeave={() => {
                  setIsHoveredOpen(false);
                  setHoveredButton(null);
                }}
                style={{
                  height: 30,
                  width: 30,
                  border: isHoveredOpen
                    ? theme.mode === "light"
                      ? "3px solid " + theme.palette.primary.main
                      : "3px solid #FFF"
                    : tab === "open"
                      ? theme.mode === "light"
                        ? "3px solid " + theme.palette.primary.main
                        : "3px solid #FFF"
                      : theme.mode === "light"
                        ? "2px solid #aaa"
                        : "2px solid #aaa",
                  borderRadius: 8,
                  marginRight: 8,
                }}
                onClick={() => handleChangeTab(null, "open")}
              >
                <MoveToInboxIcon
                  style={{
                    color: isHoveredOpen
                      ? theme.mode === "light"
                        ? theme.palette.primary.main
                        : "#FFF"
                      : tab === "open"
                        ? theme.mode === "light"
                          ? theme.palette.primary.main
                          : "#FFF"
                        : "#aaa",
                  }}
                />
              </IconButton>
            </Badge>

            <Badge
              color="primary"
              invisible={
                !(
                  tab === "closed" &&
                  !isHoveredAll &&
                  !isHoveredNew &&
                  !isHoveredResolve &&
                  !isHoveredOpen &&
                  !isHoveredSort
                ) && !isHoveredClosed
              }
              badgeContent={i18n.t("tickets.inbox.resolverd")}
              classes={{ badge: classes.tabsBadge }}
            >
              <IconButton
                onMouseEnter={() => {
                  setIsHoveredClosed(true);
                  setHoveredButton("closed");
                }}
                onMouseLeave={() => {
                  setIsHoveredClosed(false);
                  setHoveredButton(null);
                }}
                style={{
                  height: 30,
                  width: 30,
                  border: isHoveredClosed
                    ? theme.mode === "light"
                      ? "3px solid " + theme.palette.primary.main
                      : "3px solid #FFF"
                    : tab === "closed"
                      ? theme.mode === "light"
                        ? "3px solid " + theme.palette.primary.main
                        : "3px solid #FFF"
                      : theme.mode === "light"
                        ? "2px solid #aaa"
                        : "2px solid #aaa",
                  borderRadius: 8,
                  marginRight: 8,
                }}
                onClick={() => handleChangeTab(null, "closed")}
              >
                <CheckBoxIcon
                  style={{
                    color: isHoveredClosed
                      ? theme.mode === "light"
                        ? theme.palette.primary.main
                        : "#FFF"
                      : tab === "closed"
                        ? theme.mode === "light"
                          ? theme.palette.primary.main
                          : "#FFF"
                        : "#aaa",
                  }}
                />
              </IconButton>
            </Badge>
            {tab !== "closed" && tab !== "search" && (
              <Badge
                color="primary"
                invisible={
                  !isHoveredSort ||
                  isHoveredAll ||
                  isHoveredNew ||
                  isHoveredResolve ||
                  isHoveredOpen ||
                  isHoveredClosed
                }
                badgeContent={!sortTickets ? "Crescente" : "Decrescente"}
                classes={{ badge: classes.tabsBadge }}
              >
                <ToggleButton
                  onMouseEnter={() => setIsHoveredSort(true)}
                  onMouseLeave={() => setIsHoveredSort(false)}
                  className={classes.button}
                  value="uncheck"
                  selected={sortTickets}
                  onChange={() =>
                    setSortTickets((prevState) => !prevState)
                  }
                >
                  {!sortTickets ? (
                    <TextRotateUp style={{
                      color: sortTickets
                        ? theme.mode === "light"
                          ? theme.palette.primary.main
                          : "#FFF"
                        : "#aaa",
                    }} />
                  ) : (
                    <TextRotationDown style={{
                      color: sortTickets
                        ? theme.mode === "light"
                          ? theme.palette.primary.main
                          : "#FFF"
                        : "#aaa",
                    }} />
                  )}
                </ToggleButton>
              </Badge>
            )}
            
            
          </Grid>
          <Grid item>
            <TicketsQueueSelect
              selectedQueueIds={selectedQueueIds}
              userQueues={user?.queues}
              onChange={(values) => setSelectedQueueIds(values)}
            />
          </Grid>
        </Grid>
      </Paper>

      <div className={classes.serachInputWrapper}>
        <SearchIcon className={classes.searchIcon} />
        <InputBase
          className={classes.searchInput}
          inputRef={searchInputRef}
          placeholder={i18n.t("tickets.search.placeholder")}
          type="search"
          onChange={handleSearch}
        />
        {/* Indicador de loading da pesquisa */}
        {isSearching && (
          <div style={{ marginRight: '8px', display: 'flex', alignItems: 'center' }}>
            <CircularProgress size={20} />
          </div>
        )}

        <Tooltip placement="top" title="Marque para pesquisar também nos conteúdos das mensagens (mais lento)">
          <div>
            <Switch
              size="small"
              checked={searchOnMessages}
              onChange={(e) => { setSearchOnMessages(e.target.checked) }}
            />
          </div>
        </Tooltip>
      </div>

      {filter === true && (
        <>
          <DateRangeFilter 
            key={`date-filter-${filterKey}`}
            onFiltered={handleDateRangeFilter}
            onDateChange={handleDateRangeFilter}
            onFilterTypeChange={handleFilterTypeChange}
            initialDateRange={memoizedFilterValues.initialDateRange}
            initialFilterType={memoizedFilterValues.initialDateRange.filterType || "createdAt"}
          />
          <TagsFilter 
            key={`tags-filter-${filterKey}`}
            onFiltered={handleSelectedTags} 
            initialSelectedTags={memoizedFilterValues.initialSelectedTags}
          />
          <WhatsappsFilter 
            key={`whatsapps-filter-${filterKey}`}
            onFiltered={handleSelectedWhatsapps} 
            initialWhatsapps={memoizedFilterValues.initialSelectedWhatsapps}
          />
           {/* Filtro de Usuários - Para admin OU usuários com allUserChat habilitado */}
           {(() => {
             const isAdmin = user.profile === "admin" || user.profile === "ADMIN" || user.profile === "Admin";
             const hasAllUserChat = user.allUserChat === "enabled" || 
                                   user.allUserChat === "ENABLED" || 
                                   user.allUserChat === "Enabled";
             const shouldShow = isAdmin || hasAllUserChat;
             
             console.log('DEBUG - Condição UsersFilter:', {
               profile: user.profile,
               allUserChat: user.allUserChat,
               isAdmin: isAdmin,
               hasAllUserChat: hasAllUserChat,
               shouldShow: shouldShow
             });
             return shouldShow;
           })() && (
             <UsersFilter 
               key={`users-filter-${filterKey}`}
               onFiltered={handleSelectedUsers} 
               initialUsers={memoizedFilterValues.initialSelectedUsers}
             />
           )}
          
          {/* Botões Aplicar e Limpar Filtros */}
          <Paper style={{ padding: 8, marginTop: 4 }}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleApplyFilters}
                  fullWidth
                  style={{
                    fontWeight: 600,
                    textTransform: "none",
                    fontSize: "11px",
                    padding: "6px",
                  }}
                >
                  {i18n.t("tickets.filters.applyFilters")}
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleClearFilters}
                  fullWidth
                  style={{
                    fontWeight: 600,
                    textTransform: "none",
                    fontSize: "11px",
                    padding: "6px",
                  }}
                >
                  {i18n.t("tickets.filters.clearFilters")}
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </>
      )}

      <TabPanel value={tab} name="open" className={classes.ticketsWrapper}>
        <Tabs
          value={tabOpen}
          onChange={handleChangeTabOpen}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          {/* ATENDENDO */}
          <Tab
            label={
              <Grid container alignItems="center" justifyContent="center">
                <Grid item>
                  <Badge
                    overlap="rectangular"
                    classes={{ badge: `${classes.customBadge} ${classes.smoothBadge} ${pulseOpen ? classes.countPulse : ""}` }}
                    badgeContent={openCount}
                    color="primary"
                    max={9999}
                    showZero
                  >
                    <MessageSharpIcon
                      style={{
                        fontSize: 18,
                      }}
                    />
                  </Badge>
                </Grid>
                <Grid item>
                  <Typography
                    style={{
                      marginLeft: 8,
                      fontSize: 10,
                      fontWeight: 600,
                    }}
                  >
                    {i18n.t("ticketsList.assignedHeader")}
                  </Typography>
                </Grid>
              </Grid>
            }
            value={"open"}
            name="open"
            classes={{ root: classes.tabPanelItem }}
          />

          {/* AGUARDANDO */}
          <Tab
            label={
              <Grid container alignItems="center" justifyContent="center">
                <Grid item>
                  <Badge
                    overlap="rectangular"
                    classes={{ badge: `${classes.customBadge} ${classes.smoothBadge} ${pulsePending ? classes.countPulse : ""}` }}
                    badgeContent={pendingCount}
                    color="primary"
                    max={9999}
                    showZero
                  >
                    <ClockIcon
                      style={{
                        fontSize: 18,
                      }}
                    />
                  </Badge>
                </Grid>
                <Grid item>
                  <Typography
                    style={{
                      marginLeft: 8,
                      fontSize: 10,
                      fontWeight: 600,
                    }}
                  >
                    {i18n.t("ticketsList.pendingHeader")}
                  </Typography>
                </Grid>
              </Grid>
            }
            value={"pending"}
            name="pending"
            classes={{ root: classes.tabPanelItem }}
          />

          {/* GRUPOS */}
          {user.allowGroup && (
            <Tab
              label={
                <Grid container alignItems="center" justifyContent="center">
                  <Grid item>
                    <Badge
                      overlap="rectangular"
                      classes={{ badge: classes.customBadge }}
                      badgeContent={groupingCount}
                      color="primary"
                      max={9999}
                    >
                      <Group
                        style={{
                          fontSize: 18,
                        }}
                      />
                    </Badge>
                  </Grid>
                  <Grid item>
                    <Typography
                      style={{
                        marginLeft: 8,
                        fontSize: 10,
                        fontWeight: 600,
                      }}
                    >
                      {i18n.t("ticketsList.groupingHeader")}
                    </Typography>
                  </Grid>
                </Grid>
              }
              value={"group"}
              name="group"
              classes={{ root: classes.tabPanelItem }}
            />
          )}
        </Tabs>

        <Paper className={classes.ticketsWrapper}>
          <TicketsList
            key={`open-${forceSearch}-${refreshKey}-${updateTrigger}`}
            status="open"
            showAll={showAllTickets}
            sortTickets={sortTickets ? "ASC" : "DESC"}
            selectedQueueIds={selectedQueueIds}
            updateCount={updateCountOpen}
            onIdsLoaded={handleIdsLoaded}
            style={applyPanelStyle("open")}
            setTabOpen={setTabOpen}
            // Aplicar filtros quando estiverem ativos
            statusFilter={filtersApplied ? selectedStatus : undefined}
            tags={filtersApplied ? selectedTags : undefined}
            users={filtersApplied ? selectedUsers : undefined}
            whatsappIds={filtersApplied ? selectedWhatsapp : undefined}
            dateStart={filtersApplied ? appliedDateRange.dateStart : undefined}
            dateEnd={filtersApplied ? appliedDateRange.dateEnd : undefined}
            forceSearch={forceSearch}
            filterType={filtersApplied ? appliedDateRange.filterType : "createdAt"}
          />
          <TicketsList
            key={`pending-${forceSearch}-${refreshKey}-${updateTrigger}`}
            status="pending"
            selectedQueueIds={selectedQueueIds}
            sortTickets={sortTickets ? "ASC" : "DESC"}
            showAll={user.profile === "admin" || user.allUserChat === 'enabled' ? showAllTickets : false}
            updateCount={updateCountPending}
            onIdsLoaded={handleIdsLoaded}
            style={applyPanelStyle("pending")}
            setTabOpen={setTabOpen}
            // Aplicar filtros quando estiverem ativos
            statusFilter={filtersApplied ? selectedStatus : undefined}
            tags={filtersApplied ? selectedTags : undefined}
            users={filtersApplied ? selectedUsers : undefined}
            whatsappIds={filtersApplied ? selectedWhatsapp : undefined}
            dateStart={filtersApplied ? appliedDateRange.dateStart : undefined}
            dateEnd={filtersApplied ? appliedDateRange.dateEnd : undefined}
            forceSearch={forceSearch}
            filterType={filtersApplied ? appliedDateRange.filterType : "createdAt"}
          />
          {user.allowGroup && (
            <TicketsList
              key={`group-${forceSearch}-${refreshKey}-${updateTrigger}`}
              status="group"
              showAll={showAllTickets}
              sortTickets={sortTickets ? "ASC" : "DESC"}
              selectedQueueIds={selectedQueueIds}
              updateCount={(val) => setGroupingCount(val)}
              style={applyPanelStyle("group")}
              setTabOpen={setTabOpen}
              // Aplicar filtros quando estiverem ativos
              statusFilter={filtersApplied ? selectedStatus : undefined}
              tags={filtersApplied ? selectedTags : undefined}
              users={filtersApplied ? selectedUsers : undefined}
              whatsappIds={filtersApplied ? selectedWhatsapp : undefined}
              dateStart={filtersApplied ? appliedDateRange.dateStart : undefined}
              dateEnd={filtersApplied ? appliedDateRange.dateEnd : undefined}
              forceSearch={forceSearch}
              filterType={filtersApplied ? appliedDateRange.filterType : "createdAt"}
            />
          )}
        </Paper>
      </TabPanel>
      <TabPanel value={tab} name="closed" className={classes.ticketsWrapper}>
        <TicketsList
          key={`closed-${forceSearch}-${refreshKey}-${updateTrigger}`}
          status="closed"
          showAll={showAllTickets}
          selectedQueueIds={selectedQueueIds}
          setTabOpen={setTabOpen}
          // Aplicar filtros quando estiverem ativos
          statusFilter={filtersApplied ? selectedStatus : undefined}
          tags={filtersApplied ? selectedTags : undefined}
          users={filtersApplied ? selectedUsers : undefined}
          whatsappIds={filtersApplied ? selectedWhatsapp : undefined}
          dateStart={filtersApplied ? appliedDateRange.dateStart : undefined}
          dateEnd={filtersApplied ? appliedDateRange.dateEnd : undefined}
          forceSearch={forceSearch}
          filterType={filtersApplied ? appliedDateRange.filterType : "createdAt"}
        />
      </TabPanel>
      <TabPanel value={tab} name="search" className={classes.ticketsWrapper}>
        
        {searchOnMessages && searchParam.trim() ? (
          <SearchResultsDisplay 
            tickets={searchResults}
            searchParam={searchParam}
            onTicketClick={handleSearchResultClick}
            searchOnMessages={searchOnMessages}
          />
        ) : (
          <>
            {profile === "admin" && (
              <>
                                 <TicketsList
                   key={`search-admin-${forceSearch}-${refreshKey}-${updateTrigger}`}
                   statusFilter={filtersApplied ? selectedStatus : undefined}
                   searchParam={searchParam}
                   showAll={showAllTickets}
                   tags={filtersApplied ? selectedTags : undefined}
                   users={filtersApplied ? selectedUsers : undefined}
                   selectedQueueIds={selectedQueueIds}
                   whatsappIds={filtersApplied ? selectedWhatsapp : undefined}
                   forceSearch={forceSearch}
                   searchOnMessages={searchOnMessages}
                   dateStart={filtersApplied ? appliedDateRange.dateStart : undefined}
                   dateEnd={filtersApplied ? appliedDateRange.dateEnd : undefined}
                   status="search"
                   filterType={filtersApplied ? appliedDateRange.filterType : "createdAt"}
                 />
              </>
            )}

                         {profile === "user" && (
               <TicketsList
                 key={`search-user-${forceSearch}-${refreshKey}-${updateTrigger}`}
                 statusFilter={filtersApplied ? selectedStatus : undefined}
                 searchParam={searchParam}
                 showAll={false}
                 tags={filtersApplied ? selectedTags : undefined}
                 selectedQueueIds={selectedQueueIds}
                 whatsappIds={filtersApplied ? selectedWhatsapp : undefined}
                 forceSearch={forceSearch}
                 searchOnMessages={searchOnMessages}
                 dateStart={filtersApplied ? appliedDateRange.dateStart : undefined}
                 dateEnd={filtersApplied ? appliedDateRange.dateEnd : undefined}
                 status="search"
               />
             )}
          </>
        )}
      </TabPanel>
    </Paper>
  );
};

// Componente principal que envolve com o provider
const TicketsManagerTabs = () => {
  return (
    <BulkSelectionProvider>
      <TicketsManagerTabsContent />
    </BulkSelectionProvider>
  );
};

export default TicketsManagerTabs;
